import Vue from 'vue';
import UIKit from '@uikit/ui-kit';
import { ObserveVisibility } from 'vue-observe-visibility';

import '@uikit/ui-kit/lib/ui-kit.min.css';
import applyColors from '@/common/utils/applyColors';

import '@/assets/styles/app.scss';

applyColors();
Vue.use(UIKit);
Vue.directive('observe-visibility', ObserveVisibility);
